export const DOCUMENT_TYPES = {
  DNI: 1,
  NIE: 2,
  CIF: 3,
  SIGN: 529
};

// Fixed data of the UI module
export const PROVINCES = [
  { label: 'Álava', value: '01' },
  { label: 'Albacete', value: '02' },
  { label: 'Alicante', value: '03' },
  { label: 'Almería', value: '04' },
  { label: 'Ávila', value: '05' },
  { label: 'Badajoz', value: '06' },
  { label: 'Baleares', value: '07' },
  { label: 'Barcelona', value: '08' },
  { label: 'Burgos', value: '09' },
  { label: 'Cáceres', value: '10' },
  { label: 'Cádiz', value: '11' },
  { label: 'Castellón', value: '12' },
  { label: 'Ciudad Real', value: '13' },
  { label: 'Córdoba', value: '14' },
  { label: 'La Coruña', value: '15' },
  { label: 'Cuenca', value: '16' },
  { label: 'Girona ', value: '17' },
  { label: 'Granada ', value: '18' },
  { label: 'Guadalajara ', value: '19' },
  { label: 'Guipuzcoa ', value: '20' },
  { label: 'Huelva ', value: '21' },
  { label: 'Huesca ', value: '22' },
  { label: 'Jaén   ', value: '23' },
  { label: 'León  ', value: '24' },
  { label: 'Lleida ', value: '25' },
  { label: 'La Rioja  ', value: '26' },
  { label: 'Lugo   ', value: '27' },
  { label: 'Madrid ', value: '28' },
  { label: 'Málaga ', value: '29' },
  { label: 'Murcia ', value: '30' },
  { label: 'Navarra ', value: '31' },
  { label: 'Orense  ', value: '32' },
  { label: 'Asturias ', value: '33' },
  { label: 'Palencia ', value: '34' },
  { label: 'Las Palmas de G.C. ', value: '35' },
  { label: 'Pontevedra ', value: '36' },
  { label: 'Salamanca ', value: '37' },
  { label: 'Tenerife  ', value: '38' },
  { label: 'Cantabria ', value: '39' },
  { label: 'Segovia   ', value: '40' },
  { label: 'Sevilla   ', value: '41' },
  { label: 'Soria     ', value: '42' },
  { label: 'Tarragona ', value: '43' },
  { label: 'Teruel   ', value: '44' },
  { label: 'Toledo   ', value: '45' },
  { label: 'Valencia ', value: '46' },
  { label: 'Valladolid ', value: '47' },
  { label: 'Vizcaya  ', value: '48' },
  { label: 'Zamora   ', value: '49' },
  { label: 'Zaragoza ', value: '50' },
  { label: 'Ceuta  ', value: '51' },
  { label: 'Melilla ', value: '52' }
];
// End fixed data of the UI module

export const GENERIC_DRIVER_ID = 4;

export const GENERIC_DRIVER_DATA = {
  driverId: 4,
  identityDocument: {
    type: '2',
    description: 'NIF',
    documentId: ''
  },
  name: '',
  lastname: '',
  lastname2: '',
  expeditionDateDrivingLicense: '',
  address: {
    street: '',
    cityCode: '',
    stateCode: '',
    zipCode: '',
    countryCode: '011'
  },
  contactInfo: {
    mobile: '',
    email: ''
  },
  documents: []
};

export const SIGN_STATUS_SIGNED = 'signed';

export const APP_ROLES = {
  ALD_ADMIN: 'ALDAdmin', // Para desarrollo podemos añadirlo a los flujos y rutas que necesitemos
  CAMPS_MANAGER: 'GC',
  TRANSPORTATION_MANAGER: 'GT',
  LOGISTICS_DRIVER: 'CL',
  CAMPS_COORDINATOR: 'CC'
};

export const FLOW_PERMISSIONS = {
  CHECK_IN_OUT: ['GC', 'CC'],
  CAMPS: ['GC', 'CC'],
  TRANSPORTATION: ['GC', 'GT', 'CL', 'CC']
};

export const FLOW_TYPES = {
  CHECK_IN_OUT: 'checkinout',
  CAMPS: 'managementCamps',
  TRANSPORTATION: 'managementTransportation'
};

export const TEXT_TYPE_CHECK = {
  123: 'Check Sustitución',
  124: 'Check In',
  125: 'Check Out',
  128: 'Check In de Transfer',
  129: 'Check Out de Transfer'
};

export const TYPE_CHECK = {
  CHECK_SUBSTITUTION: 123,
  CHECK_IN: 124,
  CHECK_OUT: 125,
  CHECK_IN_TRANSFER: 128,
  CHECK_OUT_TRANSFER: 129
};

export const SIGN_ROUTES_NAME = {
  TRANSFER: 'transfer-sign',
  CLIENT: 'sign'
};

export const STORE_ACT_NAMES = {
  TRANSFER_ACT: 'transferAct',
  CLIENT_ACT: 'act',
  TRANSPORT_ACT: 'act'
};

// INFO: [ No esta en uso, pero se deja por si se necesita en un futuro ]
export const TRANSACTION_STATUS = {
  0: 'Nuevo',
  1: 'En modificación',
  2: 'Enviado a firma',
  3: 'Firmado',
  4: 'Custodiado',
  97: 'Finalizado',
  98: 'Anulado',
  99: 'Cancelado'
};

export const PART_TYPES = {
  1: 'parabrisas',
  2: 'capo',
  3: 'paragolpes-delantero',
  4: 'faros-delanteros',
  5: 'costado-izquierdo',
  6: 'porton-trasero',
  7: 'luneta-trasera',
  8: 'paragolpes-traseros',
  9: 'faros-traseros',
  10: 'costado-derecho',
  11: 'llantas-y-tapacubos',
  12: 'techo-capota',
  13: 'antena',
  14: 'cubrecarter'
};

export const LOGIN_TYPES = {
  EMPLOYEES: 'loginEmployees',
  PARTNERS: 'loginPartners'
};

export const LOGIN_PATHS = {
  loginEmployees: 'login/employees',
  loginPartners: 'login/partners'
};

export const OPTIONS_YES_NO = [
  { label: 'Sí', value: '1' },
  { label: 'No', value: '2' }
];

export const TYPE_YES_NO = {
  YES: '1',
  NO: '2'
};

export const TRANSPORT_STATE = {
  ACCEPTED: 'Aceptado',
  CANCELED: 'Anulado',
  ASSIGNED: 'Asignado',
  FINISHED_WITH_DISCREPANCIES: 'Terminado con discrepancias',
  IN_TRANSIT: 'En tránsito',
  FINISHED: 'Terminado',
  PENDING_ACCEPT: 'Pendiente de aceptar',
  SIGNED: 'Firmado'
};

export const REASON_STATUS_CODE = {
  REJECT: 1,
  DENY: 4,
  UNSIGNED: 2
};

// Se crea de forma dinámica un objeto que define a que inputs de los neumáticos
// se deben hacer un reset según seleccionamos.
const ATTRIBUTES = ['Width', 'Height', 'Diameter', 'Load', 'Speed'];
const generateFields = prefix => ATTRIBUTES.map(attr => `${prefix}Tyre${attr}`);
const generateResetFields = prefix => ({
  brand: generateFields(prefix),
  width: generateFields(prefix).slice(1),
  height: generateFields(prefix).slice(2),
  diameter: generateFields(prefix).slice(3),
  load: generateFields(prefix).slice(4)
});
export const TIRES_RESET_FIELDS = {
  front: generateResetFields('front'),
  rear: generateResetFields('rear')
};

export const TYRE_PROPERTIES = [
  'frontTyreBrand',
  'frontTyreWidth',
  'frontTyreHeight',
  'frontTyreDiameter',
  'frontTyreLoad',
  'frontTyreSpeed',
  'leftFrontTyreDepth',
  'rightFrontTyreDepth',
  'rearTyreBrand',
  'rearTyreWidth',
  'rearTyreHeight',
  'rearTyreDiameter',
  'rearTyreLoad',
  'rearTyreSpeed',
  'leftRearTyreDepth',
  'rightRearTyreDepth'
];

export const TIRES_DEFAULT_VALUE = {
  front: {
    speedTiresOptions: [],
    loadTiresOptions: [],
    diameterTiresOptions: [],
    heightTiresOptions: [],
    widthTiresOptions: []
  },
  rear: {
    speedTiresOptions: [],
    loadTiresOptions: [],
    diameterTiresOptions: [],
    heightTiresOptions: [],
    widthTiresOptions: []
  }
};
